import config from 'modules/config';

import client from 'config/client.json';

export default config({
  client,
});
